<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormMultiselect fieldName="offer_id"
                                         label="Offer"
                                         size="6"
                                         :options="select?.offers"
                                         v-model:field="search.offer_id" />

                        <FormMultiselect fieldName="product_id"
                                         label="Product"
                                         size="6"
                                         :options="select?.products"
                                         v-model:field="search.product_id" />
                    </div>
                    <div class="grid">
                        <FormMultiselect fieldName="assortment_id"
                                         label="Assortment name"
                                         size="6"
                                         :options="select?.assortments"
                                         v-model:field="search.assortment_id" />

                        <FormInputText fieldName="section"
                                       label="Section name"
                                       size="6"
                                       v-model:field="search.section" />
                    </div>
                    <div class="grid">
                        <FormInputNumber fieldName="price_from"
                                         label="Price from"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.price_from" />
                        <FormInputNumber fieldName="price_to"
                                         label="Price to"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.price_to" />

                        <FormInputNumber fieldName="discount_from"
                                         label="Discount from"
                                         size="2"
                                         suffix="%"
                                         :min="0"
                                         :max="100"
                                         v-model:field="search.discount_from" />
                        <FormInputNumber fieldName="discount_to"
                                         label="Discount to"
                                         size="2"
                                         suffix="%"
                                         :min="0"
                                         :max="100"
                                         v-model:field="search.discount_to" />

                        <FormInputText fieldName="unit"
                                       label="Unit"
                                       size="2"
                                       v-model:field="search.unit" />

                        <FormInputNumber fieldName="quantity_from"
                                         label="Quantity from"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.quantity_from" />
                        <FormInputNumber fieldName="quantity_to"
                                         label="Quantity to"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.quantity_to" />

                        <FormInputNumber fieldName="total_from"
                                         label="Total from"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.total_from" />
                        <FormInputNumber fieldName="total_to"
                                         label="Total to"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         v-model:field="search.total_to" />

                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ['offers', 'products', 'assortments'];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
